import * as SelectPrimitive from '@radix-ui/react-select';
import { type ComponentPropsWithoutRef } from 'react';

const Select = (props: ComponentPropsWithoutRef<typeof SelectPrimitive.Root>) => (
  <SelectPrimitive.Root data-sds-id="select" {...props} />
);

export { Select };
